var _path, _circle;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgCurrentVersion = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.800049 7.9998C0.800049 11.9998 4.00005 15.1998 8.00005 15.1998C8.45456 15.1998 8.89874 15.1585 9.32908 15.0794C9.14328 14.7764 9.00104 14.4439 8.91109 14.0905C8.61331 14.1361 8.30904 14.1598 8.00005 14.1598C4.64005 14.1598 1.84005 11.3598 1.84005 7.9998C1.84005 4.6398 4.56005 1.8398 8.00005 1.8398C11.44 1.8398 14.16 4.6398 14.16 7.9998C14.16 8.66205 14.0513 9.30253 13.8509 9.90411C14.1855 10.0516 14.4935 10.2487 14.7654 10.4859C15.0468 9.71227 15.2 8.8752 15.2 7.9998C15.2 3.9998 12 0.799805 8.00005 0.799805C4.00005 0.799805 0.800049 3.9998 0.800049 7.9998ZM10.2401 10.3195L8.48036 8.5598V3.9998H7.52036V9.03981L9.52003 11.0395C9.72484 10.7669 9.96745 10.5243 10.2401 10.3195Z",
    fill: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.3999,
    cy: 13.2002,
    r: 2,
    fill: "#24A148"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgCurrentVersion);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/current-version.9e056d94ce75aa6cd126e2769bd989df.svg";